(function () {
  'use strict';

  function initSlider(slider) {
    if (slider.dataset.agCfBound === 'true') return;
    slider.dataset.agCfBound = 'true';
    var track = slider.querySelector('[data-ag-cf-slider-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-ag-cf-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-ag-cf-slider-dot]'));
    var steps = Array.prototype.slice.call(slider.querySelectorAll('[data-ag-cf-slider-step]'));
    var progress = slider.querySelector('[data-ag-cf-slider-progress], .ag-cf-v3__transformation-progress');
    var isTransformation = slider.hasAttribute('data-ag-cf-transformation');
    var previous = slider.querySelector('[data-ag-cf-slider-prev]');
    var next = slider.querySelector('[data-ag-cf-slider-next]');
    if (!track || slides.length < 2) return;

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (progress) progress.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      if (isTransformation) {
        steps.forEach(function (step, stepIndex) {
          var active = stepIndex === index;
          step.classList.toggle('is-active', active);
          step.setAttribute('aria-current', active ? 'true' : 'false');
          step.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-current', active ? 'true' : 'false');
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }
    }

    function goTo(index) {
      var normalized = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[normalized].offsetLeft, behavior: 'smooth' });
      setActive(normalized);
    }

    if (previous) previous.addEventListener('click', function () { goTo((getIndex() || 0) - 1); });
    if (next) next.addEventListener('click', function () { goTo((getIndex() || 0) + 1); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { goTo(Number(dot.dataset.agCfSliderDot)); }); });
    steps.forEach(function (step) { step.addEventListener('click', function () { goTo(Number(step.dataset.agCfSliderStep)); }); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo((getIndex() || 0) - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo((getIndex() || 0) + 1); }
    });

    function getIndex() {
      var closestIndex = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(track.scrollLeft - slide.offsetLeft);
        if (distance < closestDistance) { closestDistance = distance; closestIndex = index; }
      });
      return closestIndex;
    }

    track.addEventListener('scroll', function () { setActive(getIndex()); }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-ag-cf-v3]').forEach(function (root) {
      root.querySelectorAll('[data-ag-cf-slider]').forEach(initSlider);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
